class ProductTabInfo {
  constructor(element) {
    this.element = element;
    this.tabs = this.element.querySelectorAll('.product-tab-info__nav-item');
    this.panels = this.element.querySelectorAll('.product-tab-info__panel');
    this.init();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;
    const targetTab = clickedTab.dataset.tab;

    this.switchTab(targetTab);
  }

  switchTab(targetTab) {
    this.tabs.forEach(tab => {
      const isActive = tab.dataset.tab === targetTab;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    this.panels.forEach(panel => {
      const expectedId = `tab-${targetTab}-${this.element.dataset.sectionId}`;
      const isActive = panel.id === expectedId;
      panel.classList.toggle('active', isActive);
    });

    this.announceTabChange(targetTab);
  }

  announceTabChange(targetTab) {
    const activeTab = this.element.querySelector(`[data-tab="${targetTab}"]`);
    const announcement = document.createElement('div');
    announcement.setAttribute('aria-live', 'polite');
    announcement.setAttribute('aria-atomic', 'true');
    announcement.className = 'visually-hidden';
    announcement.textContent = `Switched to ${activeTab.textContent.trim()} tab`;

    this.element.appendChild(announcement);

    setTimeout(() => {
      this.element.removeChild(announcement);
    }, 1000);
  }

  switchToTab(tabName) {
    const targetTab = this.element.querySelector(`[data-tab="${tabName}"]`);
    if (targetTab) {
      this.switchTab(tabName);
    }
  }

  getActiveTab() {
    const activeTab = this.element.querySelector(
      '.product-tab-info__nav-item.active'
    );
    return activeTab ? activeTab.dataset.tab : null;
  }

  reinitialize() {
    this.tabs = this.element.querySelectorAll('.product-tab-info__nav-item');
    this.panels = this.element.querySelectorAll('.product-tab-info__panel');
    this.init();
  }
}

// Decode Unicode in specification table values
function decodeSpecificationValues() {
  const specTable = document.querySelector('.specifications-table table');
  if (!specTable) return;
  if (typeof window.decodeUnicodeString !== 'function') return;

  const cells = specTable.querySelectorAll('tbody td');
  cells.forEach(cell => {
    if (cell.innerHTML) {
      const decoded = window.decodeUnicodeString(cell.innerHTML);
      if (decoded !== cell.innerHTML) {
        cell.innerHTML = decoded;
      }
    }
  });
}

// Initialize tabs when DOM is loaded
function initializeProductTabInfo() {
  const productTabInfoElements = document.querySelectorAll('.product-tab-info');

  productTabInfoElements.forEach((element, index) => {
    if (element.productTabInfo) {
      return;
    }

    element.productTabInfo = new ProductTabInfo(element);
  });

  // Decode Unicode in specification values
  decodeSpecificationValues();
}

document.addEventListener('DOMContentLoaded', initializeProductTabInfo);

window.addEventListener('load', initializeProductTabInfo);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductTabInfo);
} else {
  initializeProductTabInfo();
}

window.reinitializeProductTabs = function () {
  console.log('Manual reinitialization triggered');
  initializeProductTabInfo();
};

window.forceReinitializeProductTabs = function () {
  const productTabInfoElements = document.querySelectorAll('.product-tab-info');
  productTabInfoElements.forEach(element => {
    element.productTabInfo = null;
  });
  initializeProductTabInfo();
};

function setupMutationObserver() {
  const observer = new MutationObserver(function (mutations) {
    let shouldReinitialize = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('product-tab-info')) {
              shouldReinitialize = true;
            }
            if (node.querySelector && node.querySelector('.product-tab-info')) {
              shouldReinitialize = true;
            }
          }
        });
      }

      if (
        mutation.type === 'attributes' &&
        mutation.target.classList &&
        mutation.target.classList.contains('product-tab-info')
      ) {
        shouldReinitialize = true;
      }
    });

    if (shouldReinitialize) {
      setTimeout(initializeProductTabInfo, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-section-id', 'class'],
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(setupMutationObserver, 1000);
});

window.addEventListener('hashchange', function () {
  const hash = window.location.hash;
  if (hash.startsWith('#tab-')) {
    const tabName = hash.replace('#tab-', '').split('-')[0];
    const productTabInfoElement = document.querySelector('.product-tab-info');
    if (productTabInfoElement && productTabInfoElement.productTabInfo) {
      productTabInfoElement.productTabInfo.switchToTab(tabName);
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const hash = window.location.hash;
  if (hash.startsWith('#tab-')) {
    const tabName = hash.replace('#tab-', '').split('-')[0];
    const productTabInfoElement = document.querySelector('.product-tab-info');
    if (productTabInfoElement && productTabInfoElement.productTabInfo) {
      setTimeout(() => {
        productTabInfoElement.productTabInfo.switchToTab(tabName);
      }, 100);
    }
  }
});
